const s = {
  name: "Scale",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M4,21h10v-1c0-3.3,2.7-6,6-6s6,2.7,6,6v1h10v-1c0-8.8-7.2-16-16-16S4,11.2,4,20V21z M12.1,19H6
			c0.5-7.3,6.6-13,14-13s13.5,5.7,14,13h-6c-0.2-1.5-0.8-2.8-1.6-3.9l2.4-2.4l-1.4-1.4l-2.4,2.4C23.6,12.6,21.9,12,20,12
			C15.9,12,12.6,15.1,12.1,19z"/>
		<path class="st0" d="M0,5c0-2.8,2.2-5,5-5h30c2.8,0,5,2.2,5,5v30c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V5z M5,2C3.3,2,2,3.3,2,5v30
			c0,1.7,1.3,3,3,3h30c1.7,0,3-1.3,3-3V5c0-1.7-1.3-3-3-3H5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Scale
};
